<template>
  <div class="e-block-wrap">
    <div class="e-block e-block--flow">
      <div class="e-block__scroll" :style="{ minHeight: containerHeight }">
        <div class="e-block__title">Which are you sizing for?</div>
        <div class="e-selector-label">Choose one:</div>
        <div class="e-row e-row--gutters10">
          <div class="e-col-auto e-col-sm-12">
            <div class="e-flow-selector e-flow-selector--commercial" :class="{'e-flow-selector--commercial-fa': !fa}" @click="proceed">
              <div class="e-flow-selector__title">Sizing for a Commercial Project</div>
            </div>
          </div>
          <div class="e-col-auto e-col-sm-12">
            <div class="e-flow-selector e-flow-selector--residential" :class="{'e-flow-selector--residential-fa': !fa}" @click="switchToResidentialFlow">
              <div class="e-flow-selector__title">Sizing for a Residence (house, apartment, condo)</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="e-bottom-navbar">
      <div class="e-row">
        <div class="e-col-auto e-col-sm-12">
          <button class="e-btn e-btn--prev" @click.prevent="previous">Previous</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import { FLOW_TYPE } from '@/store';

const urlParams = new URLSearchParams(window.location.search);
const fa = urlParams.get('fa') || false;

export default {
  components: {},
  name: 'FlowSelector',
  data() {
    return {
      fa,
    };
  },
  mounted() {},
  computed: {
    ...mapState(['selectedFlow', 'containerHeight']),
    ...mapGetters(['currentQuestion']),
  },
  methods: {
    ...mapActions(['nextQuestion', 'previousQuestion', 'addParamToFilter', 'setSelectedFlow']),
    previous() {
      this.previousQuestion();
    },
    proceed() {
      this.nextQuestion(this.currentQuestion.nextId);
    },
    switchToResidentialFlow() {
      this.setSelectedFlow(FLOW_TYPE.RESIDENTIAL);
    },
  },
};
</script>

<style lang="scss">

</style>
